<script setup lang="ts">
import { type FloatingBoxProps, FloatingBox, type Emoji } from '#shared'
import { computed, toRef } from 'vue'
import StaticEmojiSelect from './static-emoji-select.vue'

interface EmojiSelectProps extends FloatingBoxProps {
  isOpen?: boolean
  size?: 'small' | 'medium' | 'large'
}

const props = defineProps<EmojiSelectProps>()

const emit = defineEmits<{
  close: []
  select: [emoji: Emoji]
}>()

const isOpen = toRef(() => props.isOpen ?? false)
const size = toRef(() => props.size ?? 'medium')

const floatingBoxProps = computed(() => {
  const { isOpen, size, ...floatingBoxProps } = props
  return floatingBoxProps
})
</script>

<template>
  <FloatingBox v-if="isOpen" v-bind="floatingBoxProps">
    <StaticEmojiSelect :size="size" :targetEl="targetEl" @close="emit('close')" @select="emit('select', $event)" />
  </FloatingBox>
</template>

<style lang="scss" module>
@use '#mixins/scrollbar' as scrollbar;

.root {
  background-color: #303035;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #404045;
}

.header {
  margin-bottom: 10px;
}

.gap {
  grid-column: 1 / -1;
}

.listWrapper {
  overflow: auto;

  @include scrollbar.hide;
}

.list {
  position: relative;
}

.listContent {
  display: grid;
  width: 100%;
}
</style>
